// The same word in Russian and Kyrgyz
const FALLBACK_ALT = 'Промо'

// Revive renders an image banner as <a><img alt="…"></a> with the alt text of the banner.
// When the field is left empty in Revive, the link has no accessible name (Lighthouse
// link-name, #296), so the banner image gets a generic one. Revive announces every
// rendered banner with a "<product>-<id>-loaded" event on the document.
export default defineNuxtPlugin(() => {
  const { reviveProduct, reviveId } = useRuntimeConfig().public
  if (!reviveId) return

  const fillAlt = (root: ParentNode) => {
    root.querySelectorAll<HTMLImageElement>('a img').forEach((img) => {
      if (!img.alt.trim()) img.alt = FALLBACK_ALT
    })
  }

  document.addEventListener(`${reviveProduct}-${reviveId}-loaded`, (event) => {
    const { id } = (event as CustomEvent<{ id?: string }>).detail
    const banner = id ? document.getElementById(id) : null
    if (banner) fillAlt(banner)
  })

  // The script is loaded from <head> and can render the first banners before this plugin runs
  document
    .querySelectorAll(`[data-${reviveProduct}-loaded]`)
    .forEach((banner) => fillAlt(banner))
})
